import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=9caf8c30&isPage"
import script from "./index.mpx?vue&type=script&lang=js&isPage"
export * from "./index.mpx?vue&type=script&lang=js&isPage"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports